import { APP_ROUTES, type AppRoutePath } from "@src/constants";
import type { Partner } from "@src/services/partners.service";

interface ReferLocationShape {
  pathname: string;
  search: string;
  hash: string;
}

interface NavigateOptions {
  state?: {
    referPath?: string;
  };
}

interface NavigateToGetStartedFromReferParams {
  markRouteAsComplete: (route: AppRoutePath) => void;
  setIsLoading: (isLoading: boolean) => void;
  navigate: (to: string, options?: NavigateOptions) => void;
  location: ReferLocationShape;
}

type SetDataFn = (key: string, value: unknown) => void;

export const navigateToGetStartedFromRefer = ({
  markRouteAsComplete,
  setIsLoading,
  navigate,
  location,
}: NavigateToGetStartedFromReferParams) => {
  markRouteAsComplete(APP_ROUTES.REFER);
  setIsLoading(false);
  navigate(APP_ROUTES.GET_STARTED, {
    state: {
      referPath: `${location.pathname}${location.search}${location.hash}`,
    },
  });
};

export const handleReferScheduleNowSuccess = (
  partners: Partner[],
  selectedPartnerId: string,
  setData: SetDataFn,
  markRouteAsComplete: (route: AppRoutePath) => void,
  setIsLoading: (isLoading: boolean) => void,
  navigate: (to: string, options?: NavigateOptions) => void,
  location: ReferLocationShape,
) => {
  const selectedPartner = partners.find((partner) => partner.id === selectedPartnerId);

  setData(
    "selectedPartnerFilteredInsurancePackages",
    selectedPartner?.filtered_insurance_packages ?? {},
  );

  navigateToGetStartedFromRefer({
    markRouteAsComplete,
    setIsLoading,
    navigate,
    location,
  });
};
